import { Box, Flex, Stack } from '../../../shared/layouts';
import {
  formatAppointmentDate,
} from '../../../../utils/dateHelpers';
import { useTranslation } from 'react-i18next';
import Button from '../../../shared/Button';
import Modal from '../../../shared/Modal';

const DeleteAppointmentModal = ({
  isOpen,
  onRequestClose,
  handleSubmit,
  currentAppointment = {},
  isSubmitting,
  appointmentDate,
}) => {
  const { t } = useTranslation();
  const {
    day = '',
    time: startTime = '',
    fullDate: startDate
  } = formatAppointmentDate(appointmentDate);
  const endTime =
    startDate && currentAppointment?.duration_without_buffer
      ? startDate.add(currentAppointment?.duration_without_buffer, 'minutes').format('HH:mm')
      : formatAppointmentDate(currentAppointment?.end_at)?.time ?? '';

  return (
    <Modal isOpen={isOpen} onRequestClose={isSubmitting ? () => {} : onRequestClose}>
      <Stack space={'m'}>
        <Box fontScale={'l'} fontWeight={'bold'}>
          {t('Weet je zeker dat je deze afspraak wilt verwijderen?')}
        </Box>
        <Box>
          <b>{currentAppointment?.public_name || currentAppointment?.name}</b>
          <Box>{day}</Box>
          <Box>{`${startTime} - ${endTime}`}</Box>
        </Box>
        <Flex
          flexDirection={{ mobile: 'column-reverse', desktop: 'row' }}
          justifyContent={{ mobile: 'flex-start', desktop: 'flex-end' }}
          css={({ space }) => ({ gap: space.m })}
        >
          <Button
            variant="primary-outline"
            width={{ mobile: '100%', desktop: 'auto' }}
            onClick={onRequestClose}
            disabled={isSubmitting}
          >
            {t('Annuleren')}
          </Button>
          <Button
            variant="alert"
            width={{ mobile: '100%', desktop: 'auto' }}
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {t('Verwijder afspraak')}
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
};

export default DeleteAppointmentModal;
